import AppointmentFormDetail from '../AppointmentFormDetail';

export default {
  data() {
    return {
      patient: {}
    }
  },

  components: {
    AppointmentFormDetail
  }
}


// WEBPACK FOOTER //
// ./src/views/Appointment/js/appointment-add.js